export default "__VITE_ASSET__DSKnraz8__"